export const ASMTasks = {
  VIEW_DASHBOARD: "ViewDashboard",
  REFERENCE_DATA: "ReferenceData",
  SEARCH_ITEM: "SearchItem",
  CREATE_ITEM: "CreateItem",
  CREATE_SUPPLIER: "CreateSupplier",
  SEARCH_SUPPLIER: "SearchSupplier",
  CREATE_CATERER: "CreateCaterer",
  SEARCH_CATERER: "SearchCaterer",
  SEARCH_ORDER: "SearchOrder",
  VIEW_MRP_DRP: "ViewMRPDRP",
  SEARCH_SCHEDULE_COUNT: "SearchScheduleCount",
  REPORTS: "Reports",
  CREATE_NDC: "CreateNDC",
  ADD_RESOURCE_PLANNING_MRP: "AddResourcePlanningMRP",
  ADD_RESOURCE_PLANNING_MRP_CATERER: "AddResourcePlanningMRPCaterer",
  ADD_RESOURCE_PLANNING_DRP: "AddResourcePlanningDRP",
  ADD_RESOURCE_PLANNING_DRP_CATERER: "AddResourcePlanningDRPCaterer",
  AUDIT_TRAIL: "AuditTrail",
};
